<template>
  <div class="service-support">
    <div class="hd">
      <img :src="require(is1920 ? '../assets/service.png' : '../assets/service2880.png')"/>
      <div class="desc">
        <p>服务支持</p>
        <p>极致的体验</p>
      </div>
    </div>
    <h3>客服常见问题</h3>
    <article>
      <aside class="left">
        <p @click="activeSec = 1" :class="{active: activeSec === 1}">一、充电桩安装流程</p>
        <p @click="activeSec = 2" :class="{active: activeSec === 2}">二、充电桩参数和匹配车型</p>
        <p @click="activeSec = 3" :class="{active: activeSec === 3}">三、充电桩使用方法</p>
        <p @click="activeSec = 4" :class="{active: activeSec === 4}">四、开票和退款</p>
        <p @click="activeSec = 5" :class="{active: activeSec === 5}">五、充电故障</p>
      </aside>
      <div class="sep"></div>
      <section class="right">
        <div v-for="(item, index) in contents[activeSec]" :key="index">
          <div class="title">{{item.title}}</div>
          <div v-for="(label, index) in item.labels" :key="index" class="label">{{label}}</div>
        </div>
      </section>
    </article>
  </div>
</template>
<script>
export default {
  name: 'ServiceSupport',
  inject: ['is1920'],
  data () {
    return {
      activeSec: 1,
      contents: {
        1: [{
          title: '1. 如何申请安装国恒充电桩？',
          labels: ['如果您有自己的固定车位和电动汽车，请您准备好报装材料，通过国恒充电APP填写信息并上传资料，我司评估符合安装条件后，需要您通过充电APP线上支付1500元技术服务费，然后由物业服务中心统一安排施工，将充电桩安装在您的产权车位（或租用车位）上。']
        },
        {
          title: '2. 在小区里安装国恒充电桩需提供哪些材料？',
          labels: ['您需要准备好有效身份证明、车位产权证明（或车位租用证明）、电动汽车行驶证，在国恒充电APP上输入相关信息，同时上传上述材料的清晰照片。']
        },
        {
          title: '3. 国恒充电桩从申请安装至使用需要多久？',
          labels: ['正常情况下，已完成电力基础设施建设的项目，自支付技术服务费之日起7-15日左右，可交付使用。']
        },
        {
          title: '4. 申请安装国恒充电桩如何收取安装费用？',
          labels: ['您提交报装材料经我司审核通过后，您签订充电设施安装使用协议，通过国恒充电APP支付1500元技术服务费即可。1500元技术服务费包含我司专业技术人员现场勘察，出具技术方案，以及充电桩使用、线缆使用、安装服务、平台使用、终身维护等。充电桩的产权归国恒充电公司所有。']
        },
        {
          title: '5. 业主私人充电桩怎样申请更换为国恒充电桩？',
          labels: ['如果您已安装的私人充电桩需要更换，请您到物业中心说明情况，并填写《充电桩更换申请表》。我们会有专门人员与您联系，免费为您更换，无需缴纳1500元技术服务费。']
        },
        {
          title: '6. 业主私有充电桩更换为国恒充电桩后，私有充电桩会被拆除吗？',
          labels: ['我司充电桩安装后，不会立刻拆除原有的充电桩。在我司充电桩能够满足您日常充电需求后，物业会与您商议具体的充电桩拆除事宜。']
        },
        {
          title: '7. 国恒充电桩比个人安装的充电桩好在哪里？',
          labels: ['我司为您更换的充电桩与您已安装的充电桩对比有三大优势：', '1）更优惠电价：我司按峰平谷分时电价收取充电电费，根据您所在的地区        和充电的时段，享受不同的优惠折扣。', '2）更长时间质保：我司提供五年超长时间质保，五年内提供免费上门服务故障处理。', '3）更安全可靠：我司自主研发的充电桩安全监控平台保障您个人的充电安全以及实时监控充电状态。']
        }
        ],
        2: [{
          title: '1. 国恒充电桩是快充还是慢充？',
          labels: ['因小区环境的电力限制，目前统一配置7kW交流慢充桩。']
        },
        {
          title: '2. 国恒充电桩的基本参数？',
          labels: ['国恒充电桩基本参数为额定电压220V，额定电流32A，功率7KW。具体参数在充电桩侧面贴有参数铭牌。实际充电电流根据客户车辆的需求输出。']
        },
        {
          title: '3. 国恒充电桩充满一台车需要多久？',
          labels: ['充满时间根据车型电池容量而定，充电桩的功率是7kw。如果是纯电动汽车，在电池没电的情况下，需要7小时左右充满；如果是混动汽车需要3个小时左右充满。']
        },
        {
          title: '4. 国恒充电桩可以给所有的电动汽车充电吗？',
          labels: ['国恒充电桩采用国标交流7孔接口，只要您的车辆充电接口符合国家交流充电标准，国恒充电桩就可以满足您的充电需求。']
        }
        ],
        3: [{
          title: '1. 如何使用国恒充电桩进行充电？',
          labels: ['在我司完成充电桩安装通电后，您通过手机扫码下载国恒充电APP进行注册，然后通过国恒充电APP扫码即可充电。']
        },
        {
          title: '2. 国恒充电桩充电收费标准是什么？费用如何支付？是否需要自购电表？',
          labels: ['您可以在国恒充电APP站点信息中查看或者充电启动后的订单详情内查看。目前对使用我司充电桩进行车辆充电的业主暂不收取充电服务费，电费是根据您实际充电量支付电费，电费单价以您所在省份居民个人电力报装电价为基准，并可按照当地的峰平谷各时段享有不同折扣优惠；充电费用可通过微信、支付宝缴费；不需业主自购电表。']
        },
        {
          title: '3. 如何查看充电明细？',
          labels: [`您可以在我们国恒充电APP，点击右下角“我的”，在“账单”中查询您的充值记录和消费记录。`]
        }
        ],
        4: [{
          title: '1. 如何开具充电发票？',
          labels: [`您可登录国恒充电APP，点击右下角“我的”，然后点击“账单”，选中您需要开票的“消费账单”，填写开票信息，申请开票即可。`]
        },
        {
          title: '2. 如何申请退款？',
          labels: [`您可以打开我们的国恒充电APP，点击右下角“我的”，再点击“余额”，在最下方点击“我要退款”即可。`]
        }
        ],
        5: [{
          title: '1. 枪连上充电桩后，扫码充电一直启动不成功，该如何处理？',
          labels: ['此种情况通常是车辆没有响应造成的，需检查车辆电源是否关闭，桩端和车端的充电枪是否确实插到位，是否停车时间过长导致车辆休眠。']
        },
        {
          title: '2. 远程预约充电启动不了，该如何处理？',
          labels: ['目前市面上部分车型不支持充电桩预约充电。如果启动失败，需要您重新开启下车门唤醒车辆，再进行充电启动。']
        },
        {
          title: '3. 小区地下室手机经常没信号，我们该怎么启动充电？',
          labels: ['您先将充电桩连接好车辆，并记录充电桩编号，在有手机信号覆盖的位置，通过输入充电桩编号启动充电。']
        },
        {
          title: '4. 充电桩显示离线，该如何处理？',
          labels: ['麻烦您通过国恒充电APP一键报修，提供车位号或者桩编号，或者拨打客服热线，我会安排技术人员跟进处理。']
        },
        {
          title: '5. 充电过程中出现故障怎么办？进行故障维修，收费吗？',
          labels: ['如果充电设备出现故障，将由专业的运维人员帮您处理。因设备质量原因造成的故障，我们免费进行维修。']
        },
        {
          title: '6. 充电车位被燃油车占位，该如何处理？',
          labels: ['需要您提供所在小区信息，我们会与您所在小区物业服务中心沟通，不断加强充电专用车位的引导和管理。']
        },
        {
          title: '7. 车辆刚淋了大雨回来，车身和底盘比较湿，可以充电吗？会不会漏电之类的？',
          labels: ['我司充电桩具备漏电检测功能，如果存在漏电，充电桩会自动保护并无法启动。我司充电桩防护等级为IP54，充电桩和电动车均具备一定的防水功能，只需保证在插枪和拔枪的时候没有雨水灌入即可。']
        },
        {
          title: '8. 为什么充电过程中会异常中断？',
          labels: ['如果现场断网或断电，您的充电是会中断的；如果现场没有断网或断电，那么原因可能是余额不足或是车端存在问题，导致跳枪充电中断。我们会联系售后服务人员到现场查看原因，尽快为您解决问题。']
        }
        ]
      }
    }
  }
}
</script>
<style lang="less">
.service-support{
  .hd{
    position: relative;
    width: 100%;
    height: 6rem;
    img{
      width: 100%;
      height: 6rem;
    }
    .desc{
      position: absolute;
      top: .97rem;
      width: 100%;
      p{
        &:first-child{
          font-size: .60rem;
          color: #333;
        }
        &:last-child{
          font-size: .28rem;
          color: #666;
        }
      }
    }
  }
  h3{
    width: 12rem;
    text-align: left;
    font-size: .28rem;
    line-height: .40rem;
    margin: .4rem auto .25rem;
  }
  article{
    width: 12rem;
    margin: 0 auto .5rem;
    background-color: white;
    padding: .3rem 0 .4rem 0;
    display: flex;
    p{
      text-align: left;
    }
    .left{
      width: 3.43rem;
      padding-left: .25rem;
      font-size: .22rem;
      color: #081530;
      p{
        margin-bottom: .3rem;
        cursor: pointer;
        &.active{
          color:  #13E4E8;
        }
      }
    }
    .sep{
      flex:  0 0 1px;
      background-color: #D8D8D8;
    }
    .right{
      width: 8.56rem;
      padding: 0 .65rem;
      >div:not(:last-child){
        margin-bottom: .25rem;
      }
      .title{
        text-align: left;
        font-size: .20rem;
        color: #081530;
        font-weight: 600;
        margin-bottom: .08rem;
      }
      .label{
        padding-left: .20rem;
        text-align: left;
        text-indent: .40rem;
        font-size: .18rem;
        line-height: .27rem;
        color:  #6D7278;
        word-wrap: break-word;
        word-break: break-all;
      }
    }
  }
}
</style>
